import imageCompression from "browser-image-compression";

const COMPRESS_OPTIONS = {
  maxSizeMB: 1,
  maxWidthOrHeight: 1600,
  useWebWorker: true,
  initialQuality: 0.8,
  fileType: "image/jpeg",
};

/**
 * Compress a single image file using browser-image-compression.
 * Returns a compressed File (JPEG by default).
 */
export async function compressImage(file: File): Promise<File> {
  const compressed = await imageCompression(file, COMPRESS_OPTIONS);
  const baseName = file.name.replace(/\.[^.]+$/, "") || "upload";

  return new File([compressed], `${baseName}.jpg`, {
    type: "image/jpeg",
    lastModified: Date.now(),
  });
}

/**
 * Compress multiple image files in parallel.
 */
export async function compressImages(files: File[]): Promise<File[]> {
  return Promise.all(files.map((f) => compressImage(f)));
}

/**
 * Convert a File to a Base64 data URL (fallback if upload endpoint is unavailable).
 */
export async function fileToBase64(file: File): Promise<string> {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = () => resolve(reader.result as string);
    reader.onerror = (err) => reject(err);
    reader.readAsDataURL(file);
  });
}

/**
 * Convert multiple Files to Base64 strings.
 */
export async function filesToBase64(files: File[]): Promise<string[]> {
  return Promise.all(files.map((f) => fileToBase64(f)));
}
